import React, { useEffect } from "react";

import { Center, Spinner } from "@chakra-ui/react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { EmptyScreen } from "@/components/features/reconciliation/EmptyScreen";
import { ReconciliationList } from "@/routes/lazyFeatures";
import {
  loadBankConnections,
  selectConnectionsSettings
} from "@/store/features/clientSettings/connections/connections";

export const ReconciliationListRoute: React.FC = () => {
  const dispatch = useDispatch();
  const { clientId } = useParams();
  const { bankConnections, isFetchingBankConnections } = useSelector(
    selectConnectionsSettings
  );

  useEffect(() => {
    dispatch(loadBankConnections(clientId!));
  }, [clientId, dispatch]);

  if (isFetchingBankConnections) {
    return (
      <Center mt={10}>
        <Spinner size="xl" color="primary.500" />
      </Center>
    );
  }

  if (!bankConnections.length) return <EmptyScreen />;

  return <ReconciliationList />;
};
